// Misc Module
// For things that don't fit in other modules
import FirebaseAPI from '@/api/firebase'
import ForeplayAPI from '@/api/foreplayServer'

export default {
  namespaced: true,
  state: {
    // Controls the collapse state of the sidebar
    sidebarCollapsed: false,
    // Sets the transition duration of the sidebar collapse
    sidebarCollapseDuration: 250,
    // Display control for the settings drawer (string or null for closed)
    settingsDrawerViewMode: null,
    // A guard that warns users when leaving a settings page without saving changes (warning message string or null for no guard)
    settingsDrawerSaveGuard: null,
    // Display control for the subscription drawer (manage & create)
    subscriptionDrawerViewMode: { state: null, initInterval: null },
    // App style (this is set in the router)
    theme: 'blue',
    lastTheme: 'blue',
    themeChangedAt: 0,
    discoveryAdCount: 0,
    preventDrawerEscapeKey: false,
    // Beta Users
    betaUsers: [],
    // Enabled PostHog feature flag keys
    featureFlags: [],
    featureFlagsLoaded: false,
    // Controls whether to display sensitive data in the UI
    isPrivateMode: false,
    // Featurebase Unread Changelogs Count
    unreadChangelogCount: 0,
    // Version for display in API views
    apiVersion: null,
    // Session-local ad display settings (which elements show on LibraryCards).
    localAdSettings: null
  },
  getters: {
    getSidebarCollapsed: state => state.sidebarCollapsed,
    getSidebarCollapseDuration: state => state.sidebarCollapseDuration,
    getSettingsDrawerViewMode: state => state.settingsDrawerViewMode,
    getSettingsDrawerSaveGuard: state => state.settingsDrawerSaveGuard,
    getSubscriptionDrawerViewMode: state => state.subscriptionDrawerViewMode?.state,
    getSubscriptionDrawerInterval: state => state.subscriptionDrawerViewMode?.initInterval,
    // Get Theme color
    getTheme: state => state.theme,
    // Get the previous theme to transtion from
    getLastTheme: state => state.lastTheme,
    // Last time the theme was updated
    getThemeChangedAt: state => state.themeChangedAt,
    // Get UTM_source UTM_medium UTM_campaign for tracking purposes
    getUtmSource: state => state.utmSource,
    getUtmMedium: state => state.utmMedium,
    getUtmCampaign: state => state.utmCampaign,
    getDiscoveryAdCount: state => state.discoveryAdCount,
    getPreventDrawerEscapeKey: state => state.preventDrawerEscapeKey,
    getBetaUsers: state => state.betaUsers,
    isFeatureEnabled: state => flag => state.featureFlags.includes(flag),
    getFeatureFlagsLoaded: state => state.featureFlagsLoaded,
    getIsPrivateMode: state => state.isPrivateMode,
    getUnreadChangelogCount: state => state.unreadChangelogCount,
    getApiVersion: state => state.apiVersion,
    getAdSettings: (state, getters, rootState, rootGetters) => {
      const user = rootGetters['AuthModule/getUser']
      if (user?.user_id) return user.adSettings
      return state.localAdSettings
    }
  },
  mutations: {
    SET_SIDEBAR_COLLAPSED (state, collapsed) {
      state.sidebarCollapsed = collapsed
    },
    SET_SETTINGS_DRAWER_VIEW_MODE (state, mode) {
      state.settingsDrawerViewMode = mode
    },
    SET_SETTINGS_DRAWER_SAVE_GUARD (state, guard) {
      state.settingsDrawerSaveGuard = guard
    },
    SET_SUBSCRIPTION_DRAWER_VIEW_MODE (state, view) {
      const { state: mode, initInterval = null } = view
      state.subscriptionDrawerViewMode.state = mode
      state.subscriptionDrawerViewMode.initInterval = mode === null ? null : initInterval
    },
    SET_THEME (state, theme) {
      console.log('setting theme')
      state.themeChangedAt = +new Date()
      state.lastTheme = state.theme
      state.theme = theme
    },
    SET_UTM_SOURCE (state, utmSource) {
      state.utmSource = utmSource
    },
    SET_UTM_MEDIUM (state, utmMedium) {
      state.utmMedium = utmMedium
    },
    SET_UTM_CAMPAIGN (state, utmCampaign) {
      state.utmCampaign = utmCampaign
    },
    SET_DISCOVERY_AD_COUNT (state, count) {
      state.discoveryAdCount = count
    },
    SET_PREVENT_DRAWER_ESCAPE_KEY (state, doPrevent) {
      state.preventDrawerEscapeKey = doPrevent
    },
    SET_BETA_USERS (state, users) {
      state.betaUsers = users
    },
    SET_FEATURE_FLAGS (state, flags) {
      state.featureFlags = flags
      state.featureFlagsLoaded = true
    },
    SET_IS_PRIVATE_MODE (state, isPrivate) {
      state.isPrivateMode = isPrivate
    },
    SET_UNREAD_CHANGELOG_COUNT (state, count) {
      state.unreadChangelogCount = count
    },
    SET_API_VERSION (state, version) {
      state.apiVersion = version
    },
    SET_LOCAL_AD_SETTINGS (state, settings) {
      state.localAdSettings = settings
    }
  },
  actions: {
    async fetchBetaUsers ({ commit }) {
      this.betaIds = await FirebaseAPI.Beta.getBetaUserIds()
      // console.log('beta ids', this.betaIds)
      commit('SET_BETA_USERS', this.betaIds)
    },
    async fetchApiVersion ({ commit }) {
      const apiInfo = await ForeplayAPI.PublicAPI.getAPIInfo()
      commit('SET_API_VERSION', apiInfo?.version ?? null)
    }
  }
}
